import { extend } from 'lodash-es';

import * as angular from 'angular';

import '../../../../js/app/notify/notify';
import '../../../../js/app/notify/themes/aptitude';
import { TokenKeeper } from '../../../../../../../../frontend/libs/shared/src/lib/services/tokenKeeper';

export default angular
  .module('httpInterceptor', ['notify'])
  .config([
    '$httpProvider',
    function ($httpProvider) {
      'use strict';

      // Implement request headers to force browsers to revalidate their cache for ajax GET requests
      // this is mainly for IE browsers since chrome and FF implement these headers by default
      // but browser defaults aren't necessarily something to rely
      // *header params must be lowercase
      var headers = extend($httpProvider.defaults.headers.common, {});

      $httpProvider.defaults.headers.common = headers;

      // For proper JSON conversion with DELETE requests
      $httpProvider.defaults.headers['delete'] = {
        'Content-Type': 'application/json;charset=utf-8',
      };

      // Hook in the interceptor any time this module is included.
      $httpProvider.interceptors.push('jsendHttpInterceptor');
    },
  ])
  .factory('jsendHttpInterceptor', [
    '$q',
    '$log',
    '$window',
    'notify',
    function ($q, $log, $window, notify) {
      ///////////////////
      // Helper functions
      ///////////////////
      const jsendHeaderValue = 'application/x-jsend';

      function verifyJsendValueInHeader(header = '') {
        return header.includes(jsendHeaderValue);
      }

      // This is a hack to re-encode our POST parameters to the same format jQuery used. Some back-end code expects that.
      function transformJSONToURLEncoded(obj) {
        var str = [];

        // IMPROVE: Use Object.keys
        // tslint:disable:forin
        for (var p in obj) {
          str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
        }

        return str.join('&');
      }

      function httpErrorDescription(status) {
        switch (status) {
          case 400:
            return 'Bad Request';
          case 401:
            return 'Unauthorized';
          case 402:
            return 'Payment Required';
          case 403:
            return 'Forbidden';
          case 404:
            return 'Not Found';
          case 405:
            return 'Method Not Allowed';
          case 406:
            return 'Not Acceptable';
          case 407:
            return 'Proxy Authentication';
          case 408:
            return 'Request Timeout';
          case 409:
            return 'Conflict';
          case 410:
            return 'Gone';
          case 411:
            return 'Length Required';
          case 412:
            return 'Precondition Failed';
          case 413:
            return 'Request Entity Too Large';
          case 414:
            return 'Request-URI Too Long';
          case 415:
            return 'Unsupported Media Type';
          case 416:
            return 'Requested Range Not Satisfiable';
          case 417:
            return 'Expectation Failed';
          case 500:
            return 'Internal Server Error';
          case 501:
            return 'Not Implemented';
          case 502:
            // Official description: "Bad Gateway"
            return `There was an error when communicating with our server. Please reload the page.`;
          case 503:
            return 'Service Unavailable';
          case 504:
            return 'Gateway Timeout. A request has timed out. Please reload the page.';
          case 505:
            return 'HTTP Version Not Supported';
          default:
            // This kicks in for really unusual circumstances like a blocked URL.
            return 'An error occurred, please reload the page. If the error persists, please let us know.';
        }
      }

      // Adds the current url to the destination so that users can be routed back to the page they left on successful login
      function redirectToLogin(urlBase, afterBase) {
        // If a timeout occurs on a page with many requests happening simultanously the redirect will fire multiple times.
        // Ensure that if the user has already been redirected that they are not redirected again
        if (document.location.href.indexOf('destination=') == -1) {
          //Strip the base from the destination to avoid a duplicate base
          var destination =
            document.location.pathname.replace(urlBase, '') +
            document.location.hash;
          document.location.href =
            urlBase +
            afterBase +
            '?destination=' +
            encodeURIComponent(destination);
        }
      }

      var interceptor = {
        // Default action taken when a JSend response with "fail" status is received.
        failAction: function defaultWarnAction(jsendResponse) {
          // We notify the end user that something went wrong.
          notify.warn(jsendResponse.message);
        },

        // Default action taken when a JSend response with "error" status is received.
        errorAction: function defaultErrorAction(jsendResponse) {
          // We notify the end user that something went wrong.
          notify.error(jsendResponse.message);
        },

        request: function (config) {
          if (
            config.intercept ||
            config.url.indexOf('/aptitude/api/') !== -1 ||
            config.url.indexOf('/apt-admin/api/') !== -1
          ) {
            // We need to change the Accept header because we want to get JSend back.
            config.headers.Accept = jsendHeaderValue;

            // Needed to handle response errors for admin since we don't set intercept there
            config.intercept = true;

            // TODO: Remove this as soon as all back-end services can accept application/json.
            // I've checked with Kemi and there are still two calls using this:
            // - /buyer/GroupImpactServiceController/setInclusionFlagAllMembers
            // - /buyer/GroupImpactServiceController/setInclusionFlag
            //
            // There is actually a story (BEND-488) for providing APIs to replace these which will allow this code to be
            // removed.
            if (config.method === 'POST' && config.postEncoding == 'legacy') {
              config.headers['Content-Type'] =
                'application/x-www-form-urlencoded; charset=UTF-8';
              config.transformRequest = transformJSONToURLEncoded;
            }
          }

          let isAdmin = document.location.href.indexOf('/apt-admin/') !== -1;

          // This is the same logic done in the new Angular HTTP interceptor as well. We're considering several
          // critera before just slapping a token on the headers.
          let tokenKeeper = isAdmin
            ? TokenKeeper.getAdminSingleton()
            : TokenKeeper.getPlatformSingleton();
          const token = tokenKeeper.getToken();

          if (
            !config.headers['Skip-Auth'] &&
            TokenKeeper.isAptitudeEndpoint(config.url) &&
            token
          ) {
            config.headers['Authorization'] = `Bearer ${token}`;
          }

          delete config.headers['Skip-Auth'];

          // Return the config or wrap it in a promise if blank.
          return config || $q.when(config);
        },

        // On request failure
        requestError: function (rejection) {
          // $log.log('requestError: ', rejection); // Contains the data about the error on the request.

          // Return the promise rejection.
          return $q.reject(rejection);
        },

        // On response success
        response: function (response) {
          // Identify a JSend response and handle it within the interceptor.
          if (verifyJsendValueInHeader(response.headers()['content-type'])) {
            // $log.log('response: ', response); // Contains the data from the response.

            if (response.data.status === 'fail') {
              // Pass the full JSend response to the warn action or the error action but when rejecting, pass through only
              // the internal data object.
              interceptor.failAction(response.data);
              return $q.reject(response.data.data);
            } else if (response.data.status === 'error') {
              // Pass the full JSend response to the warn action or the error action but when rejecting, pass through only
              // the internal data object.
              interceptor.errorAction(response.data);
              return $q.reject(response.data.data);
            } else {
              // This must be a success. Just pass through the internal data to satisfy the promise.
              return $q.when(response.data.data);
            }
          }

          // No JSend here, return the response or promise.
          return response || $q.when(response);
        },

        /**
         * On response failure
         *
         * Set config.suppressAction to true to suppress the error action
         */
        responseError: function (rejection) {
          // We swallow all of the failures with a zero status. Those are typically cancelled requests due to our leaving
          // the page with AJAX in-flight.
          //
          // Swallow in this case means that we don't display a notification.
          if (
            (rejection.config && rejection.config.intercept) ||
            verifyJsendValueInHeader(rejection.headers()['content-type'])
          ) {
            if (rejection.status !== 0 && rejection.status !== -1) {
              // We'll use a provided message from the back-end if it's available, otherwise we'll translate the HTTP
              // error code into text we can display.
              var httpError =
                rejection?.data?.message ??
                httpErrorDescription(rejection.status);

              // Expired session comming from MBV generate initiative throws error 500 so this code redirects to login.
              if (
                rejection.status === 500 &&
                document.location.href.indexOf(
                  '/aptitude/static/index.html#/generateInitiative',
                ) !== -1
              ) {
                redirectToLogin('/aptitude/static/platform/signIn', '');
              }

              if (rejection.status === 401) {
                // Redirect the user to the login page. We don't have a session to make API calls (either they arrived here
                // without a login, their session expired, the user cleared cookies, etc.).
                if (document.location.href.indexOf('/apt-admin/') !== -1) {
                  // Admin session expired, so redirect to login page if not already there
                  if (
                    document.location.href.indexOf(
                      '/apt-admin/index.html#!/signIn',
                    ) == -1
                  ) {
                    redirectToLogin('/apt-admin/', 'index.html#!/');
                  }
                } else {
                  redirectToLogin('/aptitude/static/platform/signIn', '');
                }

                // This won't come back as a rejection and we're already sending them
                // someplace to log in, so they don't really need to handle it.
                return $q.when(rejection);
              } else if (rejection.status === 403) {
                // Redirect the user to the home page. The assumption is that something has changed the user's organization
                // or something similar that make calls return "403 - Forbidden".
                document.location.href =
                  '/aptitude/static/platform/home/landing';
              } else if (
                rejection.status === 404 &&
                document.location.href.indexOf('/apt-admin/api/') !== -1
              ) {
                // Admin session expired, so redirect to login page if not already there
                if (
                  document.location.href.indexOf(
                    '/apt-admin/index.html#!/signIn',
                  ) == -1
                ) {
                  redirectToLogin('/apt-admin/', 'index.html#!/');
                }
              } else if (
                httpError &&
                rejection.headers()['content-type'] ==
                  'application/x-jsend;charset=UTF-8'
              ) {
                if (!rejection.config.suppressAction) {
                  interceptor.errorAction({ message: httpError });
                } else {
                  // If we're suppressing the default error action, unwrap the response and return it
                  rejection = rejection.data;
                }
              } else if (rejection.config.suppressAction) {
                // In case the error response doesn't have the x-jsend header set
                // If we're suppressing the default error action, unwrap the response and return it
                rejection = rejection.data;
              } else {
                // This should help with those situations where we get a 502 from the proxy and the response is
                // not marked application/x-jsend.
                interceptor.errorAction({ message: httpError });
              }
            }
          }

          // Return the promise rejection.
          return $q.reject(rejection);
        },

        // Exposed for testing purposes.
        _transformJSONToURLEncoded: transformJSONToURLEncoded,

        _httpErrorDescription: httpErrorDescription,
      };

      return interceptor;
    },
  ]).name;
